import React from 'react'
import NachweisListeAusbilder from '#components/o/NachweisListe/NachweisListeAusbilder'
import NachweisListeAzubi from '#components/o/NachweisListe/NachweisListeAzubi'
import {useSelector} from 'react-redux'
import {useParams} from 'react-router-dom'

export const AusbildungsnachweiseOverview = () => {
  const permissions = useSelector(state => state.authentication.permissions)
  const {azubiId} = useParams()

  return permissions.nachweis.viewNachweiseFromOthers ? (
    <NachweisListeAusbilder azubiId={!azubiId ? undefined : Number(azubiId)} />
  ) : (
    <NachweisListeAzubi />
  )
}

export default AusbildungsnachweiseOverview
